const ENVIRONMENT =  process.env.REACT_APP_ENVIRONMENT || 'development';


const constants = {
  DEV: {
    BASE_API_URL: process.env.REACT_APP_BACKEND_URL || 'https://testapi.poolroutemonitor.com/pool-route-monitor',
    COGNITO_CLIENT_ID: process.env.REACT_APP_COGNITO_CLIENT_ID || '4jljj55pqim5tg6fs2fnqdlot5',
    COGNITO_USER_POOL_ID: process.env.REACT_APP_COGNITO_USER_POOL_ID || 'us-east-1_GxwWtwctJ',
    AUTH_SIGNOUT_URL: ['http://localhost:3000/', 'https://testapp.poolroutemonitor.com/'],
    AUTH_CALLBACK_URL: ['http://localhost:3000/callback', 'https://testapp.poolroutemonitor.com/callback'],
    AUTH_DOMAIN: 'testauth.poolroutemonitor.com'
  },
  TEST: {
    BASE_API_URL: process.env.REACT_APP_BACKEND_URL || 'https://testapi.poolroutemonitor.com/pool-route-monitor',
    COGNITO_CLIENT_ID: process.env.REACT_APP_COGNITO_CLIENT_ID || '4jljj55pqim5tg6fs2fnqdlot5',
    COGNITO_USER_POOL_ID: process.env.REACT_APP_COGNITO_USER_POOL_ID || 'us-east-1_GxwWtwctJ',
    AUTH_SIGNOUT_URL: ['http://localhost:3000/', 'https://testapp.poolroutemonitor.com/'],
    AUTH_CALLBACK_URL: ['http://localhost:3000/callback', 'https://testapp.poolroutemonitor.com/callback'],
    AUTH_DOMAIN: 'testauth.poolroutemonitor.com'

  },
  PROD: {
    BASE_API_URL: process.env.REACT_APP_BACKEND_URL || 'https://api.poolroutemonitor.com/pool-route-monitor',
    COGNITO_CLIENT_ID: '3ar2h3n9gs6cvhhjmsefj2shsc',
    COGNITO_USER_POOL_ID: 'us-east-1_hi19KpNIc',
    AUTH_SIGNOUT_URL: ['https://app.poolroutemonitor.com'],
    AUTH_CALLBACK_URL: ['https://app.poolroutemonitor.com/callback'],
    AUTH_DOMAIN: 'auth.poolroutemonitor.com'

  }
};

let envConstants;
if (ENVIRONMENT === 'production') {
  envConstants = constants.PROD;
} else if (ENVIRONMENT === 'test') {
  envConstants = constants.TEST;
} else {
  envConstants = constants.DEV;
}


// US States list
export const US_STATES = [
  'Alabama',
  'Alaska',
  'Arizona',
  'Arkansas',
  'California',
  'Colorado',
  'Connecticut',
  'Delaware',
  'Florida',
  'Georgia',
  'Hawaii',
  'Idaho',
  'Illinois',
  'Indiana',
  'Iowa',
  'Kansas',
  'Kentucky',
  'Louisiana',
  'Maine',
  'Maryland',
  'Massachusetts',
  'Michigan',
  'Minnesota',
  'Mississippi',
  'Missouri',
  'Montana',
  'Nebraska',
  'Nevada',
  'New Hampshire',
  'New Jersey',
  'New Mexico',
  'New York',
  'North Carolina',
  'North Dakota',
  'Ohio',
  'Oklahoma',
  'Oregon',
  'Pennsylvania',
  'Rhode Island',
  'South Carolina',
  'South Dakota',
  'Tennessee',
  'Texas',
  'Utah',
  'Vermont',
  'Virginia',
  'Washington',
  'West Virginia',
  'Wisconsin',
  'Wyoming'
];

export { envConstants , ENVIRONMENT };
